import ErrorMessage from 'deprecated/atoms/errorMessage';
import Icon from 'atoms/icon';
import Input from 'deprecated/atoms/input';
import { InputInterface } from 'deprecated/atoms/input/index.d';
import * as React from 'react';
// tslint:disable-next-line
import { ReactElement } from 'react';
import classNames from 'utils/classNames';

const styles = require('./inputFormField.css');

interface InputFormFieldProps {
  label?: string;
  inputProps?: InputInterface;
  icon?: ReactElement<any>;
  iconStyle?: React.CSSProperties;
  style?: {};
  valid?: boolean;
  errorMessage?: string;
  theme?: string;
  disableUnderline?: boolean;
}

export default class InputFormField extends React.Component<
  InputFormFieldProps,
  any
> {
  public state = {
    focused: false,
  };

  public render() {
    const {
      inputProps,
      label,
      icon,
      valid,
      iconStyle = {},
      theme,
      disableUnderline,
      errorMessage,
    } = this.props;

    const error = valid !== null && valid !== undefined ? valid : false;
    const hrClasses = classNames({
      error,
      focused: this.state.focused,
    });

    const formGroupClasses = classNames({
      error,
      formGroup: true,
      [theme]: !!theme,
    });

    return (
      <div style={this.props.style} className={formGroupClasses}>
        {label && <label htmlFor={inputProps.id}>{label}</label>}
        {icon && <Icon glyph={icon} style={iconStyle} />}
        <Input
          {...{
            ...inputProps,
            withIcon: !!icon,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            valid: !error,
          }}
        />
        {!disableUnderline && <hr className={hrClasses} />}
        {error && errorMessage && (
          <ErrorMessage animated message={errorMessage} />
        )}
      </div>
    );
  }

  private onFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    this.setState({
      focused: true,
    });
  };

  private onBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    this.setState({
      focused: false,
    });

    return this.props.inputProps.onBlur && this.props.inputProps.onBlur(e);
  };
}
